import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, Type } from '@angular/core';
import { SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { Subject, Subscription } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { NbDialogService } from '@nebular/theme';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { GridCell } from '@urbannex/storethemes';
import { BaseSectionEditorDirective } from '../base-section-editor.directive';
import { EditState } from '../../../model';
import { RendererType } from '../../../editor-container/editor-model';

@Component({
  selector: 'kve-grid-editor',
  templateUrl: './grid-editor.component.html',
  styleUrls: ['./grid-editor.component.scss']
})
export class GridEditorComponent extends BaseSectionEditorDirective implements OnInit, OnChanges {
  elementId: string;
  gridThumbnails: any[];
  gridThumbnails$: Subscription;
  cellIdsThumbs: any[];
  cellIdsThumbs$: Subscription;
  selectedCell: GridCell;

  @Output() setListMode = new EventEmitter();

  destroy$: Subject<void> = new Subject<void>();

  constructor(
    sectionEditorBridge: SectionEditorBridgeService,
    private dialogService: NbDialogService,
    previewEditStoreService: PreviewEditStoreService
  ) {
    super(sectionEditorBridge, previewEditStoreService)

  }



  ngOnInit(): void {
    super.ngOnInit();
    console.log("Fokof polisiekar")
    this.gridThumbnails$ = this.sectionEditorBridge.getSectionThumbnails().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(data)
        this.gridThumbnails = data;
      })
    /* this.cellIdsThumbs$ = this.sectionEditorBridge.getCellIdsThumbs().pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      this.cellIdsThumbs = data;
    }) */
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes["selectedRenderedSection"]) {
      this.elementId = this.selectedRenderedSection.elementId;
    }
  }

  goBack(e) {
    this.setListMode.emit();
  }

  open(options: any) {
    console.log(options);
    console.log(this.selectedCell);
    if (this.selectedCell != null && this.selectedCell != undefined) {
      this.selectedCell = null;
    }
    // image header footer link
    const action = options["action"];
    const imgSrc = options["imgSrc"];
    const cellId = options["cellId"];
    console.log("SelectedSection Track before send", this.selectedSection)
    const cellToSelect = this.resolveSelectedCell(cellId);
    this.selectedCell = cellToSelect;
    console.log("selectedCell after cleanuop", this.selectedCell);
    console.log("SelectedCell Track send", this.selectedCell)
    console.log("SelectedSection Track send", this.selectedSection)
    // this.previewEditStoreService.setSelectedCell(this.selectedCell);
    // console.log(options)
    // SampleImageDirectoryComponent
    let component: Type<any> = EditorDialogComponent;
    let title = "Title"
    switch (action) {
      case "image":
        component = EditorDialogComponent;
        title = "Edit Cell"
        break;

      default:
        break;
    }
    this.previewEditStoreService.updateEditState(EditState.EDITING);
    const dialogRef = this.dialogService.open(component, {
      context: {
        title: title,
        imgSrc: imgSrc,
        cellId: cellId,
        rendererType: RendererType.GRID,
        // section: this.selectedSection,
        dialogWidth: 960
      },
    })

    dialogRef.onClose.pipe(take(1)).subscribe((resp: GridCell) => {
      console.log("Dialog closed", resp);
      if (resp != undefined) {
        console.log(resp);
        console.log(this.cellIdsThumbs);
        // This updates the thumbnail in the grid editor view
        const activeCell = this.cellIdsThumbs.find(cell => cell.cellId == resp.cellId);
        if (activeCell != null && activeCell != undefined) {
          activeCell.imgSrc = resp.imgSrc;
        }
        this.previewEditStoreService.updateSelectedCell(resp);
        this.previewEditStoreService.updateEditState(EditState.UPDATED)
      }
    })

  }

  resolveSelectedCell(cellId): GridCell {
    this.previewEditStoreService.selectedSection$.subscribe(section => {
      console.log("SelectedSection Track inside resolver", section)
    })
    let selectedCell: GridCell;
    const cells: GridCell[] = this.selectedSection.sectionData.gridOptions.gridCells;
    if (cells != undefined && cells.length > 0) {
      console.log(cells)
      selectedCell = cells.find(cell => cell.cellId == cellId);
    }
    return selectedCell;
  }


}
